import { BannerId } from '../typings/banners';
import {
    ImageSmartCenterEditorData,
    SMART_CENTER_RATIOS
} from '../typings/imageSmartCenterEditor';

export const OPEN_IMAGE_SMART_CENTER_EDITOR = 'OPEN_IMAGE_SMART_CENTER_EDITOR';
export type OPEN_IMAGE_SMART_CENTER_EDITOR = typeof OPEN_IMAGE_SMART_CENTER_EDITOR;

export interface OpenImageSmartCenterEditorAction {
    type: OPEN_IMAGE_SMART_CENTER_EDITOR;
    bannerId: BannerId;
}

export function openImageSmartCenterEditor(
    bannerId: BannerId
): OpenImageSmartCenterEditorAction {
    return {
        type: OPEN_IMAGE_SMART_CENTER_EDITOR,
        bannerId
    };
}

export const FILL_IMAGE_SMART_CENTER_EDITOR_DATA =
    'FILL_IMAGE_SMART_CENTER_EDITOR_DATA';
export type FILL_IMAGE_SMART_CENTER_EDITOR_DATA = typeof FILL_IMAGE_SMART_CENTER_EDITOR_DATA;

export interface FillImageSmartCenterEditorDataAction {
    type: FILL_IMAGE_SMART_CENTER_EDITOR_DATA;
    payload: ImageSmartCenterEditorData | undefined;
}

export function fillImageSmartCenterEditorData(
    payload: ImageSmartCenterEditorData | undefined
): FillImageSmartCenterEditorDataAction {
    return {
        type: FILL_IMAGE_SMART_CENTER_EDITOR_DATA,
        payload
    };
}

export const CLEAR_IMAGE_SMART_CENTER_EDITOR =
    'CLEAR_IMAGE_SMART_CENTER_EDITOR';
export type CLEAR_IMAGE_SMART_CENTER_EDITOR = typeof CLEAR_IMAGE_SMART_CENTER_EDITOR;

export interface ClearImageSmartCenterEditorAction {
    type: CLEAR_IMAGE_SMART_CENTER_EDITOR;
}

export function clearImageSmartCenterEditor(): ClearImageSmartCenterEditorAction {
    return {
        type: CLEAR_IMAGE_SMART_CENTER_EDITOR
    };
}

export const SET_SELECTED_IMAGE_SMART_CENTER_RATIO =
    'SET_SELECTED_IMAGE_SMART_CENTER_RATIO';
export type SET_SELECTED_IMAGE_SMART_CENTER_RATIO = typeof SET_SELECTED_IMAGE_SMART_CENTER_RATIO;

export interface SetSelectedImageSmartCenterRatioAction {
    type: SET_SELECTED_IMAGE_SMART_CENTER_RATIO;
    selectedId: SMART_CENTER_RATIOS;
}

export function setSelectedImageSmartCenterRatio(
    selectedId: SMART_CENTER_RATIOS
): SetSelectedImageSmartCenterRatioAction {
    return {
        type: SET_SELECTED_IMAGE_SMART_CENTER_RATIO,
        selectedId
    };
}

export const SET_IMAGE_SMART_CENTER_POS = 'SET_IMAGE_SMART_CENTER_POS';
export type SET_IMAGE_SMART_CENTER_POS = typeof SET_IMAGE_SMART_CENTER_POS;

export interface SetImageSmartCenterPosAction {
    type: SET_IMAGE_SMART_CENTER_POS;
    x: number;
    y: number;
}

export function setImageSmartCenterPos(
    x: number,
    y: number
): SetImageSmartCenterPosAction {
    return {
        type: SET_IMAGE_SMART_CENTER_POS,
        x,
        y
    };
}

export const SAVE_IMAGE_SMART_CENTER = 'SAVE_IMAGE_SMART_CENTER';
export type SAVE_IMAGE_SMART_CENTER = typeof SAVE_IMAGE_SMART_CENTER;

export interface SaveImageSmartCenterAction {
    type: SAVE_IMAGE_SMART_CENTER;
}

export function saveImageSmartCenter(): SaveImageSmartCenterAction {
    return {
        type: SAVE_IMAGE_SMART_CENTER
    };
}

export const SET_IMAGE_SMART_CENTER_EDITOR_ERROR =
    'SET_IMAGE_SMART_CENTER_EDITOR_ERROR';
export type SET_IMAGE_SMART_CENTER_EDITOR_ERROR = typeof SET_IMAGE_SMART_CENTER_EDITOR_ERROR;

export interface SetImageSmartCenterEditorErrorAction {
    type: SET_IMAGE_SMART_CENTER_EDITOR_ERROR;
    error?: string;
}

export function setImageSmartCenterEditorError(
    error?: string
): SetImageSmartCenterEditorErrorAction {
    return {
        type: SET_IMAGE_SMART_CENTER_EDITOR_ERROR,
        error
    };
}

export const FIX_SMART_CENTER_IMAGE_HEIGHT = 'FIX_SMART_CENTER_IMAGE_HEIGHT';
export type FIX_SMART_CENTER_IMAGE_HEIGHT = typeof FIX_SMART_CENTER_IMAGE_HEIGHT;

export interface FixSmartCenterImageHeightAction {
    type: FIX_SMART_CENTER_IMAGE_HEIGHT;
    imageHeight: number;
    imageUrl: string;
}

export function fixSmartCenterImageHeight(
    imageHeight: number,
    imageUrl: string
): FixSmartCenterImageHeightAction {
    return {
        type: FIX_SMART_CENTER_IMAGE_HEIGHT,
        imageHeight,
        imageUrl
    };
}

export type ImageSmartCenterEditorAction =
    | OpenImageSmartCenterEditorAction
    | FillImageSmartCenterEditorDataAction
    | ClearImageSmartCenterEditorAction
    | SetSelectedImageSmartCenterRatioAction
    | SetImageSmartCenterPosAction
    | SaveImageSmartCenterAction
    | SetImageSmartCenterEditorErrorAction
    | FixSmartCenterImageHeightAction;
